import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { store } from '@/redux/store';
import { resetAppState } from '@/redux/app/appSlice';
import { bootstrapPermissionCodes } from '@/utils/bootstrapPermissionCodes';
import { resolveClientDefaultPath } from '@/constants/menuPermissionMeta';
import { clearAllAuth } from '@/utils/logout';
import '../Page.less'

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.app.token);
  const [time, setTime] = useState(new Date());
  const [permLoading, setPermLoading] = useState(false);

  const handleRelogin = useCallback(() => {
    clearAllAuth(token);
    dispatch(resetAppState());
    navigate('/system/login', { replace: true });
  }, [dispatch, navigate, token]);

  const handleEnterClientHome = async () => {
    if (permLoading) return;
    setPermLoading(true);
    try {
      await bootstrapPermissionCodes(store);
      const { permissionCodesFetchFailed, permissionCodes } = store.getState().app;
      if (permissionCodesFetchFailed) {
        message.error('权限信息获取失败，请重新登录或稍后重试');
        return;
      }
      const path = resolveClientDefaultPath(permissionCodes);
      if (path === '/dashboard') {
        message.info('当前账号暂无业务系统菜单权限，仍保留在当前大屏');
        return;
      }
      navigate(path, { replace: true });
    } finally {
      setPermLoading(false);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (d) => {
    const week = ['日', '一', '二', '三', '四', '五', '六'];
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 星期${week[d.getDay()]}`;
  };

  const formatTime = (d) => {
    return d.toLocaleTimeString('zh-CN', { hour12: false });
  };

  return (
    <div className="screen-header">
      {/* 扫描线动画 */}
      <div className="header-scan-line" />

      <div className="header-left">
        <span className="header-date">{formatDate(time)}</span>
      </div>

      <div className="header-center">
        <div className="header-title-text">金宝宝月子会所可视化平台</div>
        <div className="header-decoration-line">
          <span className="deco-dot" />
          <span className="deco-line" />
          <span className="deco-diamond" />
          <span className="deco-line" />
          <span className="deco-dot" />
        </div>
        <button
          type="button"
          className="header-enter-home"
          disabled={permLoading}
          onClick={handleEnterClientHome}
        >
          {permLoading ? '正在获取权限…' : '重新进入系统首页'}
        </button>
      </div>

      <div className="header-right">
        <button
          type="button"
          className="header-relogin"
          onClick={handleRelogin}
        >
          重新登录
        </button>
        <span className="header-time">{formatTime(time)}</span>
      </div>
    </div>
  );
};

export default Header;
